import { render, staticRenderFns } from "./PercentInput.vue?vue&type=template&id=031023ac&lang=pug&"
import script from "./PercentInput.vue?vue&type=script&lang=js&"
export * from "./PercentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports